class FurzimaPetMegaMenu extends HTMLElement {
  connectedCallback() {
    this.buttons = Array.from(this.querySelectorAll('.fz-pet-mega__pet-btn:not(.fz-pet-mega__pet-btn--link)'));
    this.panels = Array.from(this.querySelectorAll('.fz-pet-mega__panel'));

    if (!this.buttons.length || !this.panels.length) return;

    this.buttons.forEach((button) => {
      button.addEventListener('mouseenter', () => this.activate(button.dataset.panel));
      button.addEventListener('focus', () => this.activate(button.dataset.panel));
      button.addEventListener('click', () => this.activate(button.dataset.panel));
    });

    const defaultPanel = this.buttons.find((btn) => btn.classList.contains('is-active'))?.dataset.panel
      || this.buttons[0]?.dataset.panel;

    if (defaultPanel) this.activate(defaultPanel);
  }

  activate(panelId) {
    if (!panelId) return;

    this.buttons.forEach((button) => {
      const isActive = button.dataset.panel === panelId;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-expanded', isActive ? 'true' : 'false');
    });

    this.panels.forEach((panel) => {
      const isActive = panel.dataset.panel === panelId;
      panel.classList.toggle('is-active', isActive);
      panel.toggleAttribute('hidden', !isActive);
    });
  }
}

if (!customElements.get('furzima-pet-mega-menu')) {
  customElements.define('furzima-pet-mega-menu', FurzimaPetMegaMenu);
}
